<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<app-topbar></app-topbar>  
<main class="layout-container">
  <div class="layout-content-wrapper">
    <router-outlet></router-outlet>
    <div class="layout-content">
       <div class="grid justify-content-center">
          <div class="col-12 md:col-10 painel-card-container">
            <p-card class="card custom-card">
              <ng-template pTemplate="header">
                <div class="card-header">
                  <h3 class="card-title">Olá, {{ userName }}</h3>
                  <div class="text-500">
                    Crie seu próprio Prompt e compartilhe com outros usuários!
                  </div>
                </div>
              </ng-template>
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                label="Criar Novo Prompt"
                class="p-button-warning mb-3 mr-3"
                [routerLink]="'/cadastro-prompt'"
              ></button>

              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                label="Cadastrar Finalidade"
                class="mb-3 bt-tema-2"
                [routerLink]="'/cadastrar-categoria'"
              ></button>

              <div class="mt-5">
                <p-table
                  [value]="prompts"
                  [paginator]="true"
                  [rows]="10"
                  [rowsPerPageOptions]="[5,10,20]"
                  styleClass="p-datatable-gridlines p-datatable-striped" 
                  responsiveLayout="stack"
                  sortField="data"
                  [sortOrder]="-1"
                >
                  <ng-template pTemplate="caption"> Meus Prompts </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th
                        pSortableColumn="titulo"
                        style="width: 65%; text-align: left"
                      >
                        Título <p-sortIcon field="titulo"></p-sortIcon>
                      </th>
                      <th
                        pSortableColumn="rating"
                        style="width: 7%; text-align: center"
                      >
                        Avaliação <p-sortIcon field="rating"></p-sortIcon>
                      </th>
                      <th
                        pSortableColumn="data"
                        style="width: 8%; text-align: center"
                      >
                        Data <p-sortIcon field="data"></p-sortIcon>
                      </th>
                      <th style="width: 12%; text-align: center">Ação</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-prompt>
                    <tr>
                      <td><span class="p-column-title">Título</span>{{ prompt.titulo }}</td>
                      <td class="text-center"><span class="p-column-title">Avaliação</span>
                        <p-rating
                          [ngModel]="prompt.rating"
                          [readonly]="true"
                          [cancel]="false"
                        ></p-rating>
                      </td>

                      <td class="text-center"><span class="p-column-title">Data</span>{{ prompt.data | date: 'dd/MM/yyyy' }}</td>
                      <td class="text-center"><span class="p-column-title">Ações</span>
                        <div class="acoes-buttons">
                        <p-button
                          icon="pi pi-eye"
                          iconPos="left"
                          pTooltip="Visualizar"
                          tooltipPosition="top"
                          styleClass="p-button-sm p-button-info"
                          (click)="visualizarPrompt(prompt.id)"
                        ></p-button>
                        <p-button
                          icon="pi pi-pencil"
                          iconPos="left"
                          pTooltip="Editar"
                          tooltipPosition="top"
                          styleClass="p-button-sm bt-tema-2"
                          [routerLink]="['/editar-prompt', prompt.id]"
                        ></p-button>
                        <p-button
                          icon="pi pi-copy"
                          iconPos="left"
                          pTooltip="Duplicar"
                          tooltipPosition="top"
                          styleClass="p-button-sm bt-tema"
                          (click)="duplicarPrompt(prompt)"
                        ></p-button>
                        <p-button
                          icon="pi pi-trash"
                          iconPos="left"
                          pTooltip="Deletar"
                          tooltipPosition="top"
                          styleClass="p-button-sm p-button-danger"
                          (click)="deletarPrompt(prompt)"
                        ></p-button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-card>
          </div>
        </div>
    </div>
  </div>
</main>
